export default "/images/vendor/lightbox2/src/loading.gif?f657825a2eeed04632b01ed85f528407";